export const SocialData= [
    {
        platform:"Instagram",
        icon: require('./../assets/icons/instagram.png'),
        link:"https://www.instagram.com/aditya.roshan.patro/",
    },
    {
        platform:"Github",
        icon: require('./../assets/icons/github.png'),
        link:"https://github.com/adityaroshanpatro",
    },
    {
        platform:"Linkedin",
        icon: require('./../assets/icons/linkedin.png'),
        link:"https://www.linkedin.com/in/aditya-patro-0278771b4/",
    },
    {
        platform:"Facebook",
        icon: require('./../assets/icons/facebook.png'),
        link:"https://www.facebook.com/aditya.patro.98/",
    },
    {
        platform:"Twitter",
        icon: require('./../assets/icons/twitter.png'),
        link:"https://twitter.com/RoshanAditya12",
    },
    {
        platform:"Gmail",
        icon: require('./../assets/icons/gmail.png'),
        link:"adityaroshanpatro@gmail.com",
    },
    
];